/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
'use client'

import React, { useEffect, useState } from 'react'
import '../../sass/menu/Items.scss'
import DetailedPopUp from './DetailedPopUp'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import Image from 'next/image'
import { allergensList, getAllergenName } from '@/lib/utils/allergensPath'
import Divider from './Divider'
import { Currency, ITheme, Language } from '@/lib/interfaces/interfaces'
import { NextFont } from 'next/dist/compiled/@next/font'
import { formatMoney } from '@/lib/utils/format'

interface ItemProps {
	icon?: IconProp
	iconStyle?: string
	detailedPopup?: boolean
	name: string
	description?: string
	detailText?: string
	allergens?: string[]
	isFood?: boolean
	descriptionIsSpanishName?: boolean
	price?: number
	halfprice?: number
	tapaprice?: number
	fourthprice?: number
	priceLabel?: string
	halfpriceLabel?: string
	tapapriceLabel?: string
	toFixedValue?: number
	allowHtmlInDescription?: boolean
	imageSource?: string
	theme: ITheme
	language: Language
	fontStyle: {
    fontFamily: NextFont;
    fontSize: string;
  },
	currency: Currency,
	orderingActive: boolean
	priceMarkup?: number
	itemId: string
}

const Item: React.FC<ItemProps> = (props) => {
  const {
    icon,
    iconStyle,
    name,
    description,
    detailText,
    detailedPopup,
    allergens,
    price,
    halfprice,
    tapaprice,
    fourthprice,
    priceLabel,
    halfpriceLabel,
    tapapriceLabel,
    isFood,
    imageSource,
    theme,
    fontStyle,
    currency,
    language,
    itemId,
    orderingActive,
    priceMarkup = 0
	  } = props

  const [showFullItem, setShowFullItem] = useState(false)

  // Manejo del evento popstate
  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      if (showFullItem) {
        setShowFullItem(false)
      }
    }

    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [showFullItem])

  // Función para abrir el popup y agregar una entrada al historial
  const openPopup = () => {
    if (!imageSource && !orderingActive) return
    setShowFullItem(true)
    window.history.pushState({ popup: true }, '')
  }

  // Función para cerrar el popup y retroceder en el historial
  const closePopup = () => {
    setShowFullItem(false)
    window.history.back()
  }

  const priceStyle = { backgroundColor: theme.items.bgPriceColor, color: theme.items.priceTextColor, fontSize: fontStyle.fontSize }
  const applyMarkup = (price: number) =>
    // En delivery el markup se guarda como cantidad fija (euros), no como porcentaje.
    orderingActive && priceMarkup > 0 ? price + priceMarkup : price

  return (
		<li>
			<article
				className={`item ${imageSource ? 'with-img' : ''}`}
				onClick={(e) => {
				  openPopup()
				}}
			>
				<div className='info'>
					<div className='first-line'>
						<h5 className={fontStyle.fontFamily.className} style={{ color: theme.items.nameColor, fontSize: fontStyle.fontSize }}>
							{icon && <FontAwesomeIcon icon={icon} className={`item-icon ${iconStyle}`} />}
							{name}
						</h5>
						{!imageSource && <hr style={{ borderColor: theme.items.lineToPriceColor }} className='line-to-price' />}
						{!imageSource && (
							<div className='prices'>
								{tapaprice !== 0 && tapaprice !== undefined && (
									<span className={fontStyle.fontFamily.className} style={priceStyle} data-price-label={tapapriceLabel?.trim() ? tapapriceLabel.trim() : undefined}>
										 {formatMoney(applyMarkup(tapaprice), currency)}
									</span>
								)}

								{halfprice !== 0 && halfprice !== undefined && (
									<span className={fontStyle.fontFamily.className} style={priceStyle} data-price-label={halfpriceLabel?.trim() ? halfpriceLabel.trim() : undefined}>
										 {formatMoney(applyMarkup(halfprice), currency)}
									</span>
								)}
								{price !== 0 && price !== undefined && (
									<span className={fontStyle.fontFamily.className} style={priceStyle} data-price-label={priceLabel?.trim() ? priceLabel.trim() : undefined}>
										 {formatMoney(applyMarkup(price), currency)}
									</span>
								)}

							</div>
						)}
					</div>
					<p className={fontStyle.fontFamily.className} style={{ color: theme.items.descriptionColor, fontSize: fontStyle.fontSize }}>{description}</p>
					{allergens && allergens.length > 0
					  ? (
						<div className='allergens-container' onClick={(e) => e.stopPropagation()}>
							{allergens.map((allergen) => (
								<div
									key={allergen}
									data-allergen={getAllergenName(allergen, language)}
									className='allergen__img-wrapper'
								>
									<Image
										className='allergen__img'
										width={40}
										height={40}
										src={allergensList[allergen].img}
										alt={allergen}
									/>
								</div>
							))}
						</div>
					    )
					  : <div style={{ height: '10px' }} />}
					{imageSource && (
						<div className='prices'>
							{tapaprice !== 0 && tapaprice !== undefined && (
								<span className={fontStyle.fontFamily.className} style={priceStyle} data-price-label={tapapriceLabel?.trim() ? tapapriceLabel.trim() : undefined}>
									 {formatMoney(applyMarkup(tapaprice), currency)}
								</span>
							)}
							{halfprice !== 0 && halfprice !== undefined && (
								<span className={fontStyle.fontFamily.className} style={priceStyle} data-price-label={halfpriceLabel?.trim() ? halfpriceLabel.trim() : undefined}>
									 {formatMoney(applyMarkup(halfprice), currency)}
								</span>
							)}
							{price !== 0 && price !== undefined && (
								<span className={fontStyle.fontFamily.className} style={priceStyle} data-price-label={priceLabel?.trim() ? priceLabel.trim() : undefined}>
									 {formatMoney(applyMarkup(price), currency)}
								</span>
							)}
						</div>
					)}
				</div>

				{imageSource && (
					<div className='img-container'>
						<Image className='img' src={imageSource} alt={`imagen de ${name}`} width={200} height={200} />
					</div>
				)}
			</article>

			{imageSource ? <Divider theme={theme} /> : <div style={{ marginTop: 15 }} />}

			{showFullItem && detailedPopup && (
				<DetailedPopUp
					name={name}
					detailText={detailText}
					description={description}
					allergens={allergens}
					isFood={isFood}
					price={price}
					halfprice={halfprice}
					tapaprice={tapaprice}
					fourthprice={fourthprice}
					priceLabel={priceLabel}
					halfpriceLabel={halfpriceLabel}
					tapapriceLabel={tapapriceLabel}
					allergenImages={allergens}
					setShowFullItem={closePopup}
					imageSource={imageSource}
					theme={theme}
					fontStyle={fontStyle}
					currency={currency}
					language={language}
					orderingActive={orderingActive}
					priceMarkup={priceMarkup}
					itemId={itemId}
				/>
			)}
		</li>
  )
}

export default Item
